/**
 * @param {Record<string, unknown>} models
 * @param {string[]} fieldKeys
 * @returns {number}
 */
export function calculateFieldCompletionPercent(models, fieldKeys) {
  if (!fieldKeys.length) {
    return 0;
  }

  const filled = fieldKeys.filter((key) => {
    const value = models[key];
    return value !== null && value !== undefined && value !== "";
  }).length;

  return (filled / fieldKeys.length) * 100;
}

/**
 * @param {unknown[]} values
 * @returns {number}
 */
export function averagePercentages(values) {
  const normalized = values.map((value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : 0;
  });

  if (!normalized.length) {
    return 0;
  }

  return Math.round(
    normalized.reduce((acc, value) => acc + value, 0) / normalized.length,
  );
}
